import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { lumi } from '@/lib/lumi'
import {Loader2, AlertTriangle} from 'lucide-react'
import NovaSolicitacao from '@/components/NovaSolicitacao'
import type { Solicitacao } from '@/types'

export default function EditarSolicitacaoPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState<Solicitacao | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    lumi.entities.solicitacoes.list({ limit: 9999 }).then(r => {
      const list = (r.list || []) as Solicitacao[]
      const found = list.find(s => s._id === id) || null
      setData(found)
      setLoading(false)
    }).catch(() => setLoading(false))
  }, [id])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-5 h-5 animate-spin mr-2" style={{ color: '#0f3b50' }} />
        <span className="text-sm text-gray-500">Carregando solicitação...</span>
      </div>
    )
  }

  if (!data) {
    return (
      <div className="text-center py-16">
        <AlertTriangle className="w-8 h-8 text-gray-300 mx-auto mb-3" />
        <p className="text-sm text-gray-500">Solicitação não encontrada.</p>
        <button
          onClick={() => navigate('/solicitacoes')}
          className="mt-3 text-sm hover:underline" style={{ color: '#0f3b50' }}
        >
          Voltar para Solicitações
        </button>
      </div>
    )
  }

  return (
    <NovaSolicitacao
      editData={data}
      onSaved={() => navigate(`/solicitacoes/${id}`)}
    />
  )
}
